<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: "HelloWorld",
  props: {
    msg: String
  }
};
</script>

<style lang="less">
html,
body {
  background-color: #07080c;
  color: #fff;
  margin: 0;
  font-family: Avenir, Helvetica, Arial, sans-serif;
}
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
}

span {
  display: inline-block;
  vertical-align: middle;
}

input,
button {
  outline: none;
  vertical-align: middle;
}

#nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #ffde27;
    }
  }
}
</style>
